// In-memory (session-only, never persisted) record of course-not-found update
// cards the user has dismissed via "Not now". Lives at module scope so it
// survives the Updates page unmounting/remounting when navigating between
// tabs, unlike component state.
const dismissed = new Set();

function key (learningObjectId, courseId) {
  return `${learningObjectId}:${courseId}`;
}

export function isDismissed (learningObjectId, courseId) {
  return dismissed.has(key(learningObjectId, courseId));
}

export function dismiss (learningObjectId, courseId) {
  dismissed.add(key(learningObjectId, courseId));
}
